import 'utils/form-analytics-klaviyo';
import 'utils/form-analytics-hubspot';
import 'utils/form-analytics-contact';

type FormProvider = 'klaviyo' | 'hubspot' | 'shopify_forms' | 'contact';

const FORM_SUBMITTED_EVENT = 'woodupp:form_submitted';

const DEDUPE_MS = 3000;
const recentKeys = new Set<string>();

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const normalizeEmail = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;

  const email = value.trim().toLowerCase();
  if (!email || !EMAIL_PATTERN.test(email)) return null;

  return email;
};

export const publishFormSubmitted = (
  provider: FormProvider,
  email: unknown,
  formId?: string,
): void => {
  const normalized = normalizeEmail(email);
  if (!normalized) return;

  const key = `${provider}|${formId ?? ''}|${normalized}`;
  if (recentKeys.has(key)) return;

  recentKeys.add(key);
  window.setTimeout(() => recentKeys.delete(key), DEDUPE_MS);

  const payload: Record<string, string> = {
    provider,
    email: normalized,
  };

  if (formId) payload.form_id = formId;

  window.Shopify?.analytics?.publish(FORM_SUBMITTED_EVENT, payload);
};

export const extractEmailFromForm = (form: HTMLFormElement): string | null => {
  const emailInput =
    form.querySelector<HTMLInputElement>('input[type="email"]') ??
    form.querySelector<HTMLInputElement>('input[name*="email" i]') ??
    form.querySelector<HTMLInputElement>('input[id*="email" i]');

  return normalizeEmail(emailInput?.value);
};
